/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountControllerDtoAccountListWithdrawalData from './AccountControllerDtoAccountListWithdrawalData';

/**
 * The AccountControllerDtoAccountListAccountData model module.
 * @module model/AccountControllerDtoAccountListAccountData
 * @version 1.0
 */
class AccountControllerDtoAccountListAccountData {
    /**
     * Constructs a new <code>AccountControllerDtoAccountListAccountData</code>.
     * @alias module:model/AccountControllerDtoAccountListAccountData
     */
    constructor() { 
        
        AccountControllerDtoAccountListAccountData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountListAccountData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountListAccountData} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountListAccountData} The populated <code>AccountControllerDtoAccountListAccountData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountListAccountData();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nickname')) {
                obj['nickname'] = ApiClient.convertToType(data['nickname'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('currentPower')) {
                obj['currentPower'] = ApiClient.convertToType(data['currentPower'], 'Number');
            }
            if (data.hasOwnProperty('maxPower')) {
                obj['maxPower'] = ApiClient.convertToType(data['maxPower'], 'Number');
            }
            if (data.hasOwnProperty('lastLoggedInAt')) {
                obj['lastLoggedInAt'] = ApiClient.convertToType(data['lastLoggedInAt'], 'Date');
            }
            if (data.hasOwnProperty('loginState')) {
                obj['loginState'] = ApiClient.convertToType(data['loginState'], 'Boolean');
            }
            if (data.hasOwnProperty('withdrawalInfo')) {
                obj['withdrawalInfo'] = AccountControllerDtoAccountListWithdrawalData.constructFromObject(data['withdrawalInfo']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountListAccountData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountListAccountData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['nickname'] && !(typeof data['nickname'] === 'string' || data['nickname'] instanceof String)) {
            throw new Error("Expected the field `nickname` to be a primitive type in the JSON string but got " + data['nickname']);
        }
        // validate the optional field `withdrawalInfo`
        if (data['withdrawalInfo']) { // data not null
          AccountControllerDtoAccountListWithdrawalData.validateJSON(data['withdrawalInfo']);
        }

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountListAccountData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
AccountControllerDtoAccountListAccountData.prototype['email'] = undefined;

/**
 * @member {String} nickname
 */
AccountControllerDtoAccountListAccountData.prototype['nickname'] = undefined;

/**
 * @member {Boolean} enabled
 */
AccountControllerDtoAccountListAccountData.prototype['enabled'] = undefined;

/**
 * @member {Number} currentPower
 */
AccountControllerDtoAccountListAccountData.prototype['currentPower'] = undefined;

/**
 * @member {Number} maxPower
 */
AccountControllerDtoAccountListAccountData.prototype['maxPower'] = undefined;

/**
 * @member {Date} lastLoggedInAt
 */
AccountControllerDtoAccountListAccountData.prototype['lastLoggedInAt'] = undefined;

/**
 * @member {Boolean} loginState
 */
AccountControllerDtoAccountListAccountData.prototype['loginState'] = undefined;

/**
 * @member {module:model/AccountControllerDtoAccountListWithdrawalData} withdrawalInfo
 */
AccountControllerDtoAccountListAccountData.prototype['withdrawalInfo'] = undefined;






export default AccountControllerDtoAccountListAccountData;

